import * as React from "react";
import * as ReactDOM from "react-dom";
import { FirebaseOptions } from "firebase/app";
import PushNotificationsStore from "../../store/pushNotifications.store";

declare global {
  interface Window {
    react_render_push_notifications: (nodeId: string, data: PushNotificationsProps) => void;
    chrome: any;
    opr: any;
  }
}

export type PushNotificationsConfig = {
  authToken: string,
  host: string,
  serviceWorker: string,
  firebaseOptions: FirebaseOptions,
  firebaseVAPID: string,
  userId: number,
  pushEnabled: boolean,
  debug: boolean
};

interface PushNotificationsProps {
  config: PushNotificationsConfig,
}

export const PushNotifications: React.FC<PushNotificationsProps> = (props) => {
  React.useEffect(() => {
    props.config.debug && console.log("Push Notification ON witch config:", props.config);
    const pushNotificationsStore = new PushNotificationsStore();
    pushNotificationsStore.init(props.config);
  }, []);
  
  return (
    null
  )
}

window.react_render_push_notifications = (nodeId: string, data: PushNotificationsProps) => {
  ReactDOM.render(
    <PushNotifications {...data} />,
    document.getElementById(nodeId)
  );
};